<template>
  <div class="login-page">
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">

              <!-- Password change form -->
              <form v-if="mustChangePassword" @submit.prevent="changePassword">
                <card type="login">
                  <div class="text-center">
                    <img src='static/img/VertiHub-Logo.svg' width="60%" slot="header">
                  </div>
                  <div class="alert alert-warning text-center mb-3">
                    <i class="bi bi-exclamation-triangle-fill"></i> Bitte ändere dein Passwort, um fortzufahren.
                  </div>

                  <fg-input v-model="newPassword" addon-left-icon="bi bi-key" placeholder="Neues Passwort"
                            type="password" required></fg-input>

                  <fg-input v-model="newPasswordConfirm" addon-left-icon="bi bi-key" placeholder="Neues Passwort wiederholen"
                            type="password" required></fg-input>

                  <br>

                  <p-button native-type="submit" slot="footer" type="success" block class="mb-3" :disabled="changingPassword">
                    <span v-if="changingPassword"><i class="bi bi-arrow-repeat spin-icon"></i> Passwort wird geändert…</span>
                    <span v-else>Passwort ändern</span>
                  </p-button>
                  <div v-if="error" class="alert alert-danger text-center mt-1"><i class="bi bi-exclamation-triangle-fill"></i> {{error}}</div>
                </card>
              </form>

              <!-- Forgot password form -->
              <form v-else-if="showForgotPassword" @submit.prevent="forgotPassword">
                <card type="login">
                  <div class="text-center">
                    <img src='static/img/VertiHub-Logo.svg' width="60%" slot="header">
                  </div>
                  <p class="text-center text-muted mb-3">Gib deinen Benutzernamen ein. Wenn dein Konto mit einem Mitarbeiter verknüpft ist, erhältst du ein neues Passwort per E-Mail.</p>

                  <fg-input v-model="forgotUsername" addon-left-icon="bi bi-person"
                            placeholder="Benutzername" autofocus required></fg-input>

                  <br>

                  <p-button native-type="submit" slot="footer" type="success" block class="mb-3" :disabled="forgotLoading">Passwort zurücksetzen</p-button>
                  <div class="text-center">
                    <a href="#" @click.prevent="showForgotPassword = false; error = ''; forgotSuccess = false">Zurück zur Anmeldung</a>
                  </div>
                  <div v-if="forgotSuccess" class="alert alert-success text-center mt-3"><i class="bi bi-check-circle-fill"></i> Falls ein verknüpftes Konto existiert, wurde ein neues Passwort per E-Mail gesendet.</div>
                  <div v-if="error" class="alert alert-danger text-center mt-1"><i class="bi bi-exclamation-triangle-fill"></i> {{error}}</div>
                </card>
              </form>

              <!-- Normal login form -->
              <form v-else @submit.prevent="login">
                <card type="login">
                  <div class="text-center">
                    <img src='static/img/VertiHub-Logo.svg' width="60%" slot="header">
                  </div>
              

                  <fg-input v-model="form.username" addon-left-icon="bi bi-person"
                            placeholder="Benutzername" autofocus required></fg-input>

                  <fg-input v-model="form.password" addon-left-icon="bi bi-key" placeholder="Passwort"
                            type="password" required></fg-input>

                  <br>

                  <p-button native-type="submit" slot="footer" type="success" block class="mb-3">Anmelden</p-button>
                  <div class="text-center">
                    <a href="#" @click.prevent="showForgotPassword = true; error = ''">Passwort vergessen?</a>
                  </div>
                  <div v-if="error" class="alert alert-danger text-center mt-1"><i class="bi bi-exclamation-triangle-fill"></i> {{error}}</div>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-login.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Checkbox, Button } from 'src/components/UIComponents';
  import AppFooter from './Layout/AppFooter'
  import { firebaseApp, fc } from '../../../../firebaseDb'
  import firebase from 'firebase/compat/app'
  import { httpsCallable } from "firebase/functions";

  export default {
    components: {
      Card,
      AppFooter,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
        data() {
      return {
        form: {
          username: '',
          password: ''
        },
        error: "",
        mustChangePassword: false,
        newPassword: '',
        newPasswordConfirm: '',
        changingPassword: false,
        showForgotPassword: false,
        forgotUsername: '',
        forgotLoading: false,
        forgotSuccess: false,
      }
    },
    methods: {
      login() {
        let user = this.form.username.includes('@')
          ? this.form.username
          : this.form.username + '@' + process.env.VUE_APP_USERNAME_SUFFIX
        firebaseApp
          .auth()
          .signInWithEmailAndPassword(user, this.form.password)
          .then(data => {
            return data.user.getIdTokenResult(true).then(({ claims }) => {
              if (!claims.role || (claims.role == 60)) {
                this.error = "Der Benutzer ist für den Zugriff auf VertiHub nicht autorisiert."
                firebaseApp.auth().signOut()
              } else if (claims.mustChangePassword) {
                this.error = ""
                this.mustChangePassword = true
              } else {
                this.$router.push({ name: "Overview" })
              }
            })
          })
          .catch(err => {
            console.log("Auth error: " + err.code)
            this.form.password = ""
            if (err.code === "auth/user-not-found") {
              this.error = "Benutzer wurde nicht gefunden."
            } else if (err.code === "auth/wrong-password") {
              this.error = "Passwort ungültig."
            } else if (err.code === "auth/invalid-email") {
              this.error = "Der Benutzername ist ungültig."
            } else if (err.code === "auth/too-many-requests") {
              this.error = "Der Benutzer wurde aufgrund zu vieler fehlgeschlagener Anmeldeversuche temporär gesperrt."
            } else if (err.code === "auth/user-disabled") {
              this.error = "Der Benutzer ist deaktiviert."
            } else {
              this.error = "Anmeldung fehlgeschlagen (" + err.message + ")"
            }
          })
      },
      changePassword() {
        this.error = ""
        if (this.newPassword.length < 8) {
          this.error = "Das Passwort muss mindestens 8 Zeichen lang sein."
          return
        }
        if (this.newPassword !== this.newPasswordConfirm) {
          this.error = "Die Passwörter stimmen nicht überein."
          return
        }
        this.changingPassword = true
        var changePw = httpsCallable(fc, "users-changePassword");
        changePw({ newPassword: this.newPassword }).then(() => {
          // Re-authenticate with new password to get a fresh session & token
          let user = this.form.username.includes('@')
            ? this.form.username
            : this.form.username + '@' + process.env.VUE_APP_USERNAME_SUFFIX
          return firebaseApp.auth().signInWithEmailAndPassword(user, this.newPassword)
        }).then(() => {
          this.mustChangePassword = false
          this.changingPassword = false
          this.$router.push({ name: "Overview" })
        }).catch(err => {
          this.changingPassword = false
          this.error = err.message || "Fehler beim Ändern des Passworts."
        })
      },
      forgotPassword() {
        this.error = ""
        this.forgotSuccess = false
        if (!this.forgotUsername.trim()) {
          this.error = "Bitte gib deinen Benutzernamen ein."
          return
        }
        this.forgotLoading = true
        var forgot = httpsCallable(fc, "users-forgotPassword");
        forgot({
          username: this.forgotUsername.trim(),
          usernameSuffix: process.env.VUE_APP_USERNAME_SUFFIX
        }).then(() => {
          this.forgotLoading = false
          this.forgotSuccess = true
        }).catch(err => {
          this.forgotLoading = false
          this.error = err.message || "Fehler beim Zurücksetzen des Passworts."
        })
      }
    }
  }
</script>
<style>
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.spin-icon {
  display: inline-block;
  animation: spin 1s linear infinite;
}
</style>
